import React, { useState } from 'react';
import { Loader } from 'semantic-ui-react';
import './style.less';
import ResidentInterests from './ResidentInterests';

const WellnessTab = () => {
    // Hide the list only until the first fetch finishes. Chip taps and unrelated
    // profile updates (such as a photo save) load again, but the list stays in
    // the layout and is only dimmed, so scroll position and focus stay put.
    const [loading, setLoading] = useState<boolean>(true);
    const [hasLoaded, setHasLoaded] = useState(false);
    const onLoading = (next: boolean) => {
        setLoading(next);
        if (!next) setHasLoaded(true);
    };

    return (
        <div className="sect">
            <div className="sect-header">
                <div className="sect-icon wellness">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" /></svg>
                </div>
                <div className="sect-title">Dimensions of Wellness</div>
            </div>
            <div className="sect-body">
                {loading && !hasLoaded && (
                    <div className="wellness-loader">
                        <Loader active inline="centered">Loading</Loader>
                    </div>
                )}
                <div
                    className={loading ? (hasLoaded ? 'wellness-refreshing' : 'wellness-interests-pending') : undefined}
                    aria-busy={loading}
                >
                    <ResidentInterests setLoading={onLoading} />
                </div>
            </div>
        </div>
    );
};

export default WellnessTab;
